
















































import { computed, defineComponent } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import BaseDownloadButton from "@/components/BaseDownloadButton";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import PlayButton from "@/components/PlayButton";
import StereoVideo from "@/components/StereoVideo";

export default defineComponent({
  name: "ContentFeedGalleryItem",
  components: { BaseIcon, StereoVideo, PlayButton, BaseImage, BaseDownloadButton },
  props: {
    file: { type: Object as () => ContentFile, required: true },
    clicked: { type: Boolean, required: true },
    activeFileId: { required: true, type: String },
    isFullScreen: { type: Boolean, default: false },
    videoAutoPlay: { type: Boolean, default: true },
    accessed: { type: Boolean, default: false },
    showNsfwIcon: { type: Boolean, default: false },
  },
  setup(props) {
    const active = computed(() => props.activeFileId === props.file.id && (props.videoAutoPlay || props.clicked));
    const isPlayableVideo = computed(
      () => isVideoFile(props.file) && ["NEW", "CONVERTING"].indexOf(props.file.processingStatus) === -1
    );
    const canDownloadFiles = computed(() => config.featureDownload && props.accessed);
    const videoSrc = computed(() => MediaFilesController.getVideoUrl(props.file.urlPart));
    const imageSrc = computed(() =>
      isVideoFile(props.file)
        ? MediaFilesController.getVideoThumbnail(props.file.urlPart, "1080p")
        : isImageFile(props.file)
        ? MediaFilesController.getImageThumbnail(props.file.urlPart, "1080p")
        : `/img/content-no-preview.svg`
    );
    const fileUrl = computed(() => MediaFilesController.getFileUrl(props.file.urlPart));

    return { active, isPlayableVideo, videoSrc, imageSrc, fileUrl, canDownloadFiles };
  },
});
